module.exports = __webpack_public_path__ + "static/media/foretagstraning.d74e0370.png";